import React from 'react'
import Resume from '../../assets/Joyanti Chowdhury_ Frontend-developer (2).pdf'

 const CTA = () => {
  return (
    <div className='cta'>
            <a href={Resume} download className='btn btn-primary'>DownLoad Resume</a>
            <a href="#contact" className='btn btn-primary'>Lets Talk</a>
    </div>
  )
}
export default CTA;
